import { REDUCER } from '../reducers/reducersConst';
import * as classroomGroupActions from './classroom/classroomGroupActions';
import * as classroomActions from './classroom/classroomActions';
import * as bookActions from './bookActions';
import * as assignmentsDrawerActions from './assignmentsDrawerActions';
import { I18n } from 'react-redux-i18n-lite';
import { DRAWER_CONTENTS } from '../const';

export let openDrawerAndSetContent = content => {
  return async dispatch => {
    dispatch(setDrawerData(content));
    dispatch(setDrawerOpen());
    if (content === DRAWER_CONTENTS.CREATE_ASSIGNMENTS_FROM_BOOK) {
      dispatch(assignmentsDrawerActions.setTitleTask(`${I18n.t('panels.assignment.newAssignment')}`));
    }
  };
};

export let getContentAndOpen = (content, idClassroom, bookId) => {
  return dispatch => {
    dispatch(classroomGroupActions.getClassroomGroups(idClassroom));
    dispatch(classroomActions.getClassroomParticipants(idClassroom));
    dispatch(bookActions.getBookActivities(idClassroom, bookId, true));

    dispatch(openDrawerAndSetContent(content));
  };
};

export let closeDrawerAndRemoveContent = () => {
  return dispatch => {
    dispatch(setDrawerData());
    dispatch(setDrawerClosed());
  };
};

export let setDrawerData = content => {
  return {
    type: REDUCER.DRAWER.SET_CONTENT,
    content
  };
};

export let setDrawerClosed = () => {
  return {
    type: REDUCER.DRAWER.CLOSE
  };
};

export let setDrawerOpen = () => {
  return {
    type: REDUCER.DRAWER.OPEN
  };
};
